export var error = function (msg) {
    throw new Error(msg);
};
//# sourceMappingURL=errors.js.map